import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent
  }
})
export default class ConditionsComponent extends Vue {

  mounted(){
    const _ = this;
  }

}
